var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.018,
    height: 34.018,
    viewBox: "0 0 34.018 34.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8587",
    "data-name": "Rectangle 8587",
    width: 34.018,
    height: 34.018,
    transform: "translate(-0.018)",
    fill: "#2f67d8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9538",
    "data-name": "Group 9538",
    transform: "translate(0.018)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14582",
    "data-name": "Path 14582",
    d: "M1248.765,300.132a17.132,17.132,0,1,0-19.817,16.924V305.085h-4.34v-4.953h4.34v-3.775c0-4.293,2.57-6.664,6.482-6.664a26.264,26.264,0,0,1,3.826.334v4.216H1237.1a2.471,2.471,0,0,0-2.784,2.677v3.212h4.74l-.756,4.953h-3.983v11.971A17.139,17.139,0,0,0,1248.765,300.132Z",
    transform: "translate(-1214.5 -283)",
    fill: "#2f67d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFb);
export default __webpack_public_path__ + "static/media/blue-fb.53d8245ff427ecc385059cd303047328.svg";
export { ForwardRef as ReactComponent };